<div class="footer">
  <div class="row">
    <div class="col-12">
      <img src="assets/icons/logo-footer.png" alt="" class="logo">
      <i>{{phone}}</i>
      <i class="material-icons">&#xE0B0;</i>
    </div>
  </div>
</div>
